import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useCookies } from "react-cookie";
import { useEffect } from "react";

import { SET_ACCESS_TOKEN, RESTE_ALL_AUTH_DATA } from "../../../redux/action/auth/type";

export const API_BASE =
    process.env.REACT_APP_API_URL || "http://localhost:3000";

const axiosAdmin = axios.create({
    baseURL: API_BASE,
});

export default function useAxiosAdmin() {

    const accessToken = useSelector(state => state.auth.accessToken);
    const dispatch = useDispatch();

    const [cookies] = useCookies(["refreshToken"]);

    useEffect(() => {

        // request interceptor
        const requestInterceptor = axiosAdmin.interceptors.request.use(
            (config) => {

                if (accessToken) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }

                return config;
            }
        );


        // response interceptor
        const responseInterceptor = axiosAdmin.interceptors.response.use(

            (response) => response,

            async (error) => {

                const originalRequest = error.config;

                if (error.response?.status === 401 && !originalRequest._retry) {

                    originalRequest._retry = true;

                    try {

                        const refreshToken = cookies?.refreshToken;

                        if (!refreshToken) {
                            throw new Error("No refresh token");
                        }

                        const res = await axios.post(
                            `${API_BASE}/api/auth/refresh-token`,
                            { refreshToken }
                        );

                        const newAccess = res.data?.accessToken;

                        dispatch({
                            type: SET_ACCESS_TOKEN,
                            payload: newAccess
                        });

                        originalRequest.headers.Authorization = `Bearer ${newAccess}`;

                        return axiosAdmin(originalRequest);

                    } catch (err) {

                        dispatch({ type: RESTE_ALL_AUTH_DATA });

                        window.location.href = "/auth";

                        return Promise.reject(err);
                    }
                }

                return Promise.reject(error);
            }
        );

        return () => {
            axiosAdmin.interceptors.request.eject(requestInterceptor);
            axiosAdmin.interceptors.response.eject(responseInterceptor);
        };

    }, [accessToken, cookies, dispatch]);

    return axiosAdmin;
}